export default "__VITE_ASSET__CMuafuit__"